import {
  IsBoolean,
  IsDefined,
  IsNumber,
  IsOptional
} from 'class-validator';
import { EdiConnectionType } from '../../enum/edi';
import { EdiConnectionDetails } from '../../models/edi/connection-details.type';

export class EdiIntegrationUpdateRequestDto {
  @IsNumber()
  id: number;

  @IsNumber()
  supplierId: number;

  @IsNumber()
  merchantId: number;

  @IsNumber()
  messageTypeId: number;

  @IsOptional()
  @IsBoolean()
  enabled: boolean = false;
  
  @IsOptional()
  @IsBoolean()
  sendEmail: boolean = false;

  @IsDefined()
  connectionType: EdiConnectionType;

  @IsOptional()
  @IsBoolean()
  requireOrderConfirmation?: boolean = false;

  @IsNumber()  
  connectionId: number;

  @IsDefined()
  connectionDetails: EdiConnectionDetails;
}

